<div class="btn-wrapper">
  <button
    class="btn btn-primary-dark border-0 margin-right-5 float-right"
    type="button"
    (click)="goToDetailPage()"
    placement="left"
  >
    <i class="fa fa-chevron-right margin-right-5"></i
    >{{ fromListPage ? '候補表示' : '候補を探す' }}
  </button>
</div>
